export const SOCKET_URL = "localhost:6303";
// export const AGORA = {
//   NAME: "main",
//   API_ID: "578ab0ce63e14e62877e8f529b7e446a",
//   TEMP: "006578ab0ce63e14e62877e8f529b7e446aIADv1TStDjzxwf8craa+6R8CAze6L74VM+Pkw3kM/8G6nGTNKL8AAAAAEADchOPNiQ1oYgEAAQCJDWhi",
// };
export const BASE_URL = 'http://localhost:7993';
// export const BASE_URL = "https://hangstream-backend.vercel.app";
